module.exports = {
  patron: require('./patron'),
  clinician: require('./clinician'),
  sttRoomConfig: require('./sttRoomConfig'),
  reports: require('./reports'),
};
